import { useQuery } from '@tanstack/react-query';
import {
  fetchArpSignals,
  fetchCertainSignals,
  fetchRegistrationLog,
} from '../api/registrationLogApi';

export function useRegistrationLog(searchParam: string) {
  return useQuery({
    queryKey: ['registration-log', { searchParam }],
    queryFn: () => fetchRegistrationLog({ searchParam }),
  });
}

export function useCertainSignals(registrationCode: string | null) {
  return useQuery({
    queryKey: ['certain-signals', registrationCode],
    queryFn: () => fetchCertainSignals(registrationCode!),
    enabled: !!registrationCode,
  });
}

export function useArpSignals(registrationCode: string | null) {
  return useQuery({
    queryKey: ['arp-signals', registrationCode],
    queryFn: () => fetchArpSignals(registrationCode!),
    enabled: !!registrationCode,
  });
}
